import { InvoiceAccountingStatus } from '../../../invoices/shared/models/invoice-accounting-status';
import { UserModel } from '../../../../core/user-model.model';
import { CustomerModel } from '@admin/customers/shared/models/customer-model';
import { VatStatusEnum } from '@admin/customers/shared/models/customer-vat-status.enum';
import { AccountStatusEnum } from '@admin/customers/shared/models/account-status.enum';
import { Serializable } from '@admin/core/models/serializable';
import { InvoiceStatus } from '@admin/billing/invoices/shared/models/invoice-status';

export class PaymentModel implements Serializable<PaymentModel> {
  fromObject(obj: any): PaymentModel {
    Object.assign(this, obj);
    this.activeInvoiceCoverages = [];
    if (
      obj.activeInvoiceCoverages &&
      obj.activeInvoiceCoverages.length &&
      obj.activeInvoiceCoverages.length > 0
    ) {
      obj.activeInvoiceCoverages.forEach((c) => {
        let t = new InvoiceCoverageModel();
        t = t.fromObject(c);
        this.activeInvoiceCoverages.push(t);
      });
    }

    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  constructor() {
    this.activeInvoiceCoverages = [];
  }

  public paymentId: number;

  public code: string;

  public payerAccount: AccountModel; //PayerCustomerAccountId

  public paymentDate: Date;

  public createDate: Date;

  public createUser: UserModel; //CreateUserId

  public paymentChannel: PaymentChannelEnum; //PaymentChannelId

  public amount: number;

  public originalAmount: number;

  public isDeleted: boolean;

  public amountLeft: number;

  public lastModifiedDate: Date;

  public lastModifiedUser: UserModel; //LastModifiedUserId

  public deleteDate: Date;

  public deleteUser: UserModel; //DeleteUserId

  public lastAmountEditDate: Date;

  public lastAmountEditUser: UserModel; //LastAmountEditUserId

  public activeInvoiceCoverages: InvoiceCoverageModel[];

  public comment: string;

  public activeInvoiceCoverageCodes: string[];
}

export class AccountModel implements Serializable<AccountModel> {
  fromObject(object: any): AccountModel {
    Object.assign(this, object);
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public accountId: number;

  public get displayName() {
    return this.customer.legalName;
  }

  public customer: CustomerModel;

  public vatStatus: VatStatusEnum;

  public creditLimit: number;

  public balance: number;

  public availableAmount: number;

  public status: AccountStatusEnum;

  public createDate: Date;

  public lastChangeDate: Date;
}

export class InvoiceCoverageModel
  implements Serializable<InvoiceCoverageModel>
{
  fromObject(object: any): InvoiceCoverageModel {
    throw new Error('Method not implemented.');
  }
  toObject() {
    throw new Error('Method not implemented.');
  }
  public invoiceCoverageId: number;

  public get displayName() {
    return this.invoice.code;
  }

  public get key() {
    return this.invoice.invoiceId;
  }

  public invoice: InvoiceModel; //InvoiceId

  public payment: PaymentModel; //PaymentId

  public amount: number;

  public lastAmountEditDate: Date;

  public lastAmountEditUser: UserModel;

  public createUser: UserModel; //CreateUserId

  public createDate: Date;

  public isDeleted: boolean;

  public deleteDate: Date;

  public deleteUser: UserModel; //DeleteUserId
}

export class InvoiceModel implements Serializable<InvoiceModel> {
  fromObject(object: any): InvoiceModel {
    Object.assign(this, object);
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public invoiceId: number;

  public code: string;

  public serialNumber: number;

  public createDate: Date;

  public payerAccount: AccountModel; //PayerAccountId

  public totalAmount: number;

  public vATAmount: number;

  public amountLeft: number;

  public status: InvoiceStatus; //StatusId

  public isApproved: boolean;

  public invoiceAccountingStatus: InvoiceAccountingStatusEnum; //InvoiceAccountingStatus

  public invoiceFileId: string;

  public isMerged: boolean;

  public mergeTargetInvoice: InvoiceModel; //MergeTargetInvoiceId

  public createUser: UserModel; //CreateUserId

  public approveUser: UserModel; //ApproveUserId

  public approveDate: Date;

  public payOffDate: Date;

  public deleteDate: Date;

  public deleteUser: UserModel; //DeleteUserId

  public lastStatusChangeDate: Date;

  public lastStatusChangeUser: UserModel;

  public relatedTransactions: TransactionRecordModel[];

  public invoiceCoverages: InvoiceCoverageModel[];
}

export class TransactionRecordModel
  implements Serializable<TransactionRecordModel>
{
  fromObject(object: any): TransactionRecordModel {
    throw new Error('Method not implemented.');
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public TransactionRecordId: number;

  public Code: string;

  public CreateDate: Date;

  public OriginalPayerAccount: AccountModel;

  public PayerAccount: AccountModel;

  public OriginalPaymentMethod: PaymentMethodEnum;

  public PaymentMethod: PaymentMethodEnum;

  public OriginalOrder: OrderModel;

  public Order: OrderModel;

  //public PortfolioAccountManager SalesCustomerPortfolioAccountManager:

  public OriginalProFormaInvoiceFileId: string;

  public ProFormaInvoiceFileId: string;

  //public string InvoiceFileId: //TODO: merged invoices case

  public Invoice: InvoiceModel; //InvoiceId

  public InitialPartialApproveUser: UserModel;

  public InitialCompleteApproveUser: UserModel;

  public CancelDate: Date;

  public CancelUser: UserModel;

  public RejectDate: Date;

  public RejectUser: UserModel;

  public ReverseDate: Date;

  public ReverseUser: UserModel;

  public InitialPartialApproveDate: Date;

  public InitialCompleteApproveDate: Date;

  public FinalApproveUser: UserModel;

  public FinalApproveDate: Date;

  public OrderTotalAmount: number; //TODO remove ? get from order ?

  public TaxesTotalAmount: number;

  public IsTaxFree: boolean;

  public OrderTotalAmountWithDiscount: number;

  public InvoiceTotalAmount: number;

  public ApprovalStatus: TransactionApprovalStatusEnum;

  public TransactionStatus: TransactionStatusEnum;

  public LastModifiedUser: UserModel;

  public LastModifiedDate: Date;

  public LastOrderEditDate: Date;

  public LastOrderEditUser: UserModel;

  public LastOrderTotalAmountWithDiscountEditUser: UserModel;

  public LastOrderTotalAmountWithDiscountEditDate: Date;

  public LastPayerEditUser: UserModel;

  public LastPayerEditDate: Date;

  public CreateUser: UserModel;

  public IsProFormaInvoiceSent: boolean;

  public ProFormaInvoiceSendDate: Date;

  public ProFormaInvoiceSendUser: UserModel;

  public LastSendProformaInvoiceFileId: string;
}

export class OrderModel {}

export enum PaymentChannelEnum {
  BankTransfer = 1,
  CardPayment = 2,
}

export enum InvoiceAccountingStatusEnum {
  Empty = 1,
  Sent = 2,
  Corrected = 3,
  Canceled = 4,
}

export enum PaymentMethodEnum {
  CreditPaid = 1,
  Prepaid = 2,
  Barter = 3,
  Internal = 4,
}

export enum TransactionApprovalStatusEnum {
  NotApproved = 1,
  InitialApprovePartial = 2,
  InitialApproveComplete = 3,
  FinalApprove = 4,
}

export enum TransactionStatusEnum {
  Pending = 1,
  Canceled = 2,
  Processing = 3,
  Rejected = 4,
  Complete = 5,
  Reversed = 6,
}
